export default __webpack_public_path__ + "static/media/blog4.60aa6cec.svg";